import React from 'react';
import AltContainer from 'alt-container';
import connectToStores from 'alt-utils/lib/connectToStores';
import SidebarStore from 'stores/SidebarStore';
import SidebarActions from 'actions/SidebarActions';
import SidebarToggler from 'components/pure/search/SidebarToggler';

class SidebarTogglerContainer extends React.Component {
  static getStores() {
    return [SidebarStore];
  }

  static getPropsFromStores() {
    return {
      sidebarOpen: SidebarStore.getState().get('open'),
    };
  }

  render() {
    return (
      <AltContainer
        actions={{
          SidebarActions: SidebarActions,
        }}>
        <SidebarToggler {...this.props} />
      </AltContainer>
    );
  }
}

export default connectToStores(SidebarTogglerContainer);
